export const CertOrderCheckStatus = ({ status }) => {
    let result;
    switch (status) {
        case 0: result = <span className="text-info">Новый заказ</span>;
        break;
        case 1: result = <span className="text-warning">Отправлен на кассу</span>;
        break;
        case 2: result = <span className="text-success">Выдан клиенту</span>;
        break;
        default: result = <span>Некорректные данные</span>
    }
    return result;
}